// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase, ref } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
};

// const PublicFirebaseConfig = {
//   apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
//   appId: import.meta.env.VITE_FIREBASE_APP_ID,
//   authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
//   databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
//   messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
//   projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
//   storageBucket: import.meta.env.VITE_FIREBASE_PUBLIC_STORAGE_BUCKET,
// };

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const firebaseAuth = getAuth(firebaseApp);
const firebaseDb = getDatabase(firebaseApp);
const dbRef = ref(firebaseDb);
const storage = getStorage(firebaseApp);
const publicStorage = getStorage(firebaseApp, import.meta.env.VITE_FIREBASE_PUBLIC_STORAGE_BUCKET);
const firebaseSecondDb = getDatabase(
  firebaseApp,
  import.meta.env.VITE_FIREBASE_DATABASE_SECOND_URL
);
const configDBRef = ref(firebaseSecondDb);
const firestoreDB = getFirestore(firebaseApp);

export {
  firebaseDb,
  firebaseAuth,
  firebaseApp,
  storage,
  dbRef,
  firebaseSecondDb,
  firestoreDB,
  publicStorage,
  configDBRef,
};
